<header class="header">
  <section class="page-section header-section">
    <div class="container header-container">
      <div class="header-container-left">
        <a
          routerLink="{{ isGuest ? '' : '/home' }}"
          class="header-logo-container"
          aria-label="Go to homepage"
          role="link"
          tabindex="0"
        >
          <img src="/assets/images/logo/box-unpacked-logo.svg" alt="Box Logo" class="header-logo-container-image" />
        </a>
        <div
          [reactComponent]="boxHeaderDeliveryDetailsComponent$"
          [props]="{
            address,
            timeslot,
            onAddressChange: onAddressChangeCallBack,
            onTimeslotChange: onTimeslotChangeCallback
          }"
        ></div>
      </div>
      <header-search *ngIf="isHomePage && !isSeoLocationPage" class="header-container-search"></header-search>
      <div class="header-container-right">
        <rewards-balance-badge></rewards-balance-badge>
        <box-navigation-menu class="box-navigation-menu"></box-navigation-menu>
        <box-cosmote-id-button
          class="box-cosmote-id-button"
          [class.box-cosmote-id-button-hidden]="!authenticated"
        ></box-cosmote-id-button>
      </div>
    </div>
  </section>
</header>
